import { Component, Fragment, Prop, h } from '@stencil/core';

import { onQuestionAnswered } from '../../../actions/actions.answers';
@Component({
  tag: 'question-multiselect',
  styleUrl: 'question-multiselect.css',
})
export class QuestionMultiselect {
  @Prop() errorMessage: string = '';
  @Prop() hasError: boolean = false;
  @Prop() isDirty: boolean = false;
  @Prop() heading: string = '';
  @Prop() options = [];
  @Prop({ mutable: true }) optionAnswers: { [key: string]: { value: string | boolean; comment?: string } };
  @Prop() questionId: string = '';
  @Prop() subHeading: string = '';
  @Prop() shouldDisplayHeading: boolean = true;
  @Prop() displaySubHeading: boolean = true;
  @Prop() whenChanged: (key: string, value: boolean) => void = () => {};
  @Prop() dataTestId: string = '';

  onAnswerChanged(answerId, answerValue) {
    const updatedAnswer = { ...this.optionAnswers[answerId], ...{ value: answerValue } };
    this.saveAnswer(answerId, updatedAnswer);
  }

  onCommentChanged(answerId, answerComment) {
    const updatedAnswer = { ...this.optionAnswers[answerId], ...{ comment: answerComment } };
    this.saveAnswer(answerId, updatedAnswer);
  }

  // copying original object, changing the value/comment and assigning to prop
  // bc stencil checks for object *reference* changes to trigger re-render
  saveAnswer(answerId, updatedAnswer: { value: boolean | string; comment?: string }) {
    this.optionAnswers = { ...this.optionAnswers, ...{ [answerId]: updatedAnswer } };
    onQuestionAnswered(answerId, updatedAnswer.value, updatedAnswer.comment);
  }

  renderChoices = () => {
    return this.options.map((opt) => {
      // attempted clarification: in questions of type MultiSelect,
      // option value == text of question and optionAnswer value === value of answer
      const questionText = opt.value;
      const answerId = opt.qRef;
      const answerValue = this.optionAnswers[answerId].value;

      const checkboxClassList = {
        'xs:w-full sm:w-auto': true,
      };
      const commentClassList = {
        'mt-2 mb-4 w-full': true,
        hidden: !answerValue,
      };

      return (
        <Fragment>
          <input-checkbox-toggle
            titleText={questionText}
            captionText={opt.subHeading}
            isChecked={Boolean(answerValue)}
            whenChanged={() => this.onAnswerChanged(answerId, !answerValue)}
            class={checkboxClassList}
            hasError={this.isDirty && this.hasError}
            data-testId={this.dataTestId ? `${this.dataTestId}InputCheckBoxToggle` : null}
          />

          {opt.acceptsComment && (
            <div class={commentClassList}>
              <input-multiline
                label="Comments"
                shouldDisplayCharCount={true}
                maxLength={300}
                whenChanged={(c) => this.onCommentChanged(answerId, c)}
                value={this.optionAnswers[answerId].comment}
                data-testId={this.dataTestId ? `${this.dataTestId}InputMultiLine` : null}
              />
            </div>
          )}
        </Fragment>
      );
    });
  };

  render() {
    return (
      <div class="mb-2">
        {(this.heading || this.subHeading) && (
          <div class="mb-4">
            {this.shouldDisplayHeading && this.heading && <h4 class="font-bold mb-2 text-ico-heading">{this.heading}</h4>}
            {this.displaySubHeading && this.subHeading && <div class="text-sm text-ico-body">{this.subHeading}</div>}
          </div>
        )}

        <div class="flex flex-wrap gap-2 md:gap-4">{this.renderChoices()}</div>
        {this.hasError && this.isDirty && <div class="text-xs pl-4 text-ico-error">{this.errorMessage}</div>}
      </div>
    );
  }
}
